// CONCEPT: dialogs are interaction code, not a prerequisite for rendering a catalog page.
// USE: showAlert(config) preserves SweetAlert's promise result; a failed chunk never confirms.
let loading;

export function showAlert(config) {
    if (!loading) {
        loading = import('sweetalert2').then(
            ({ default: Swal }) => Swal,
            (error) => {
                loading = undefined;
                throw error;
            }
        );
    }
    return loading.then(
        (Swal) => Swal.fire(config),
        (error) => {
            console.error('[dialog] Could not load dialog', error);
            window.alert('Could not open this message. Please reload the page and try again.');
            return { isConfirmed: false, isDenied: false, isDismissed: true };
        }
    );
}
